<template>
  <div class="hello">
    <div class="bg" :style="{background:'url('+ imageUrl +')',backgroundSize:'cover'}">
      <div class="footer">
        <div class="title">
          <span>我的投票</span>
        </div>
        <div class="line"></div>
        <div class="content">
          <div class="lefts" v-if="detail.audit_status ==0 || detail.audit_status == 2 ">
            <div class="headerImg">
              <div class="iamgeHead">
                <img src="../assets/image/defaultHeader.png"
                  alt="">
              </div>
              <div class="boll">
                <span>{{detail.photographer_name}}</span>
              </div>
            </div>
          </div>
          <div class="lefts" v-if="detail.audit_status ==1 ">
            <div class="updataImage">
              <div class="updatahead">
               <img v-if="detail.photographer_img != ''" :src="detail.photographer_img" alt="">
                <img src="../assets/image/defaultHeader.png"
                  alt="">
              </div>
              <div class="boll">
                <span>{{detail.photographer_name}}</span>
              </div>
              <div class="pla">
                <span>排名：{{detail.rank}}</span>
              </div>
              <div class="plas">
                <span>票数：{{detail.number}}</span>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="works" v-for="(item,index) in detail.vote_work" :key="index">
              <img :src="item.display_path" alt="">
            </div>
            <div class="clear"></div>
            <div style="height: 50px;"></div>
          </div>
        </div>
        <div class="foots" v-if="detail.audit_status !=1 ">
          <div class="titles">
            <span>审核状态:</span>
          </div>
          <div class="rightIn">
            <span style="font-size: 14px;" :class="{error:detail.audit_status == 2,success:detail.audit_status == 0}">{{detail.audit_status_text == '未审核'? '审核中' : detail.audit_status_text}}</span>
            <div class="inpu" >
              <span v-if="detail.audit_status == 2" style="margin-left: 15px;font-size: 14px;">{{detail.audit_fail_opinion}}</span>
            </div>
          </div>
        </div>
        <div class="updataBtn" v-if="detail.audit_status !=0 &&  detail.audit_status != 1" @click="modify">
          <span>修改</span>
        </div>
      </div>
    </div>

    <div class="addMask" v-if="addMaShow">
      <div class="addcontent">
        <div class="navTop">
          <span>
            添加参展人
          </span>
        </div>
        <div class="contentLabel">
          <div class="tabLab">
            <div class="labelName">
              展览作品
            </div>
            <div class="select">
              <div class="name">
                {{worksName}}
              </div>
            </div>
          </div>
          <div class="tabLab">
            <div class="labelName">
              摄影师
            </div>
            <div class="select">
              <div class="user">
                {{userName}}
              </div>
            </div>
          </div>
          <div class="lines"></div>
          <div class="tabLab">
            <div class="labelName">
              摄影师作品
            </div>
            <div class="work">
              <div class="addlist" v-for="(item,index) in uploadList" :key="index" @click="uploadEvent(index)">
                <img :src="item.display_path" alt="">
              </div>
            </div>
          </div>
          <div class="lines"></div>
          <div class="tabLab">
            <div class="labelName">
              上传图片
            </div>
            <div class="work">
              <div class="upload" v-for="(item,index) in work" :key="index">
                <img :src="item.display_path" alt="">
                <div class="closeOme" @click="closeoEvent(index)">
                  <img src="../assets/image/close.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="submit" @click="submitB">
          <span>报名</span>
        </div>
        <div style="height: 100px;"></div>
      </div>
    </div>
  </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        imageUrl: require('../assets/image/banner1.png'),
        detail: {},
        addMaShow: false,
        uploadList: [],
        userName: '',
        worksName: '',
        works: [],
        work: [],
        photographer_id: 0
      }
    },
    created() {
      console.log(this.$route.query.item_id);
      this.ajaxFunc();
    },
    methods: {
      ajaxFunc() {
        var data = {
          item_id: this.$route.query.item_id
        }
        this.$fetch('/center/voteDetail', data).then(res => {
          this.detail = res.data;
        })
        this.addMaShow = false;
      },
      modify() {
        var data = {
          item_id: this.$route.query.item_id
        }
        this.$fetch('/center/voteEditInfo', data).then(res => {
          this.uploadList = res.data.upload_work;
          this.work = res.data.vote_work;
          this.userName = res.data.photographer_name;
          this.worksName = res.data.exhibition_apply_name
          this.photographer_id = res.data.photographer_id;
        })
        this.addMaShow = true;
      },
      uploadEvent(index) {

        this.uploadList[index].work_id = this.uploadList[index].id;
        if (this.work.indexOf(this.uploadList[index]) == -1) {
          this.work.push(this.uploadList[index])
        }
        var result = [];
        var obj = {};
        for (var i = 0; i < this.work.length; i++) {
          if (!obj[this.work[i].work_id]) {
            result.push(this.work[i]);
            obj[this.work[i].work_id] = true;
          }
        }
        this.work = result;
      },
      closeoEvent(index) {
        this.work.splice(index, 1)
      },
      unique(arr) {
        const res = new Map();
        return arr.filter((arr) => !res.has(arr) && res.set(arrs, 1));
      },
      submitB() {
        console.log(this.$route.query.item_id);
        console.log(this.photographer_id);
        var obj = {}
        for (var i = 0; i < this.work.length; i++) {
          if (!obj[this.photographer_id]) {
            obj[this.photographer_id] = [];
          }
          obj[this.photographer_id].push(this.work[i].work_id);
        }
        var that = this;
        var data = {
          item_id: this.$route.query.item_id,
          data: obj
        }
        this.$post('/center/voteEdit', data).then(res => {
          if (res.code == 200) {
            this.$message.success('修改成功');
            that.ajaxFunc();
          }
        })
      }
    }
  }
</script>

<style scoped="scoped">
  @import url("../assets/css/examine.css");
</style>



// WEBPACK FOOTER //
// src/pages/examine.vue